import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import padlockIcon from "../assets/icons/padlock.svg";
import logoSmall from "../assets/images/logoSmallGrey.svg";
import { ArrowLeft, Loader2 } from "lucide-react";
import CurrencyFormatter from "../utils/currencyFormatter";
export default function ConfirmTransfer({
  transferObject,
  setTransfer,
  setConfirm,
  onDone,
  finalLoading,
}) {
  const formatter = new CurrencyFormatter();
  return (
    <>
      <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
        <div
          className="mr-5 border-rounded rounded-full p-1 border"
          onClick={() => {
            setTransfer(true);
            setConfirm(false);
          }}
        >
          <ArrowLeft size={14} />
        </div>
        <p className="text-sm font-medium">
          Settings / Sub accounts / Transfer funds
        </p>
      </div>
      <div className="min-h-screen flex justify-center mt-12 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full">
          <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <CardHeader className="px-9 pt-6 pb-4">
              <CardTitle className="text-2xl font-semibold text-[#6D6584] text-[20px]">
                <div className="flex items-center">
                  <div>Review your deposit</div>
                </div>
              </CardTitle>
            </CardHeader>

            <CardContent className="px-9 pt-2  pb-6">
              <div className="columns-1 mb-6">
                <div className="relative w-full border-[1px] rounded-[12px] border-[#ecebef] ">
                  <div className="flex justify-between border-b-[1px] border-[#ecebef] rounded-t-[12px] w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] px-5 py-5">
                    <p className=" text-[14px] font-normal ">You Transfer</p>
                    <p className=" text-[14px] font-semibold text-[#423E51] ">
                      {formatter?.format(
                        transferObject?.amount,
                        transferObject?.asset?.toUpperCase()
                      )}
                    </p>
                  </div>
                  <div className="flex justify-between text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-5">
                    <p className=" text-[14px] font-normal ">Transfer from</p>
                    <p className=" text-[14px] font-semibold text-[#423E51] ">
                      {transferObject?.accountIdFromName}
                    </p>
                  </div>
                  <div className="flex justify-between border-t-[1px] border-[#ecebef] rounded-b-[12px] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-5">
                    <p className=" text-[14px] font-normal ">Transfer to</p>
                    <p className=" text-[14px] font-semibold text-[#423E51] ">
                      {transferObject?.accountIdToName}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex justify-center py-3">
                <Button
                  className="bg-gradient-to-tr from-purple-500 to-rose-500 text-white py-6 rounded-full w-[40%]"
                  onClick={() => {
                    onDone?.();
                  }}
                >
                  {finalLoading && <Loader2 className="animate-spin w-4 h-4" />}
                  Confirm
                </Button>
              </div>
            </CardContent>
            <Separator />
            <div className="py-4 text-[14px] text-[#6D6584] font-normal">
              <div className="flex justify-center items-center">
                <img src={padlockIcon} className="mr-1" />
                <p>Secured by</p>
                <img src={logoSmall} className="ml-1" />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
